var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBronzeMedal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.935,
    height: 34,
    viewBox: "0 0 24.935 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 26152"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 39588",
    d: "m28.956 349.944-1.362.066-2.64 7.585a.349.349 0 0 0 .366.462l3.7-.388a.349.349 0 0 1 .28.1l2.66 2.6a.349.349 0 0 0 .574-.135l2.657-7.634-.784-.76z",
    transform: "translate(-23.262 -326.468)",
    style: {
      fill: "#ff4b56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 39589",
    d: "m72.182 332.135.537-1.543-7.6-2.585-.535 1.538a13.949 13.949 0 0 0 7.6 2.589",
    transform: "translate(-60.251 -306.004)",
    style: {
      fill: "#d61521"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 39590",
    d: "m200.1 349.944 1.362.066 2.64 7.585a.349.349 0 0 1-.366.462l-3.7-.388a.349.349 0 0 0-.28.1l-2.66 2.6a.349.349 0 0 1-.574-.135l-2.657-7.634.784-.76z",
    transform: "translate(-180.854 -326.468)",
    style: {
      fill: "#ff4b56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 39591",
    d: "m186.391 332.135-.537-1.543 7.6-2.585.535 1.538a13.949 13.949 0 0 1-7.598 2.59z",
    transform: "translate(-173.386 -306.004)",
    style: {
      fill: "#d61521"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 39592",
    d: "M12.676 24.158C.208 24.158.214 12.047.224 11.839a12.468 12.468 0 0 1 24.9 0c.01.208.016 12.319-12.452 12.319",
    transform: "translate(-.208)",
    style: {
      fill: "#eb843b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 39593",
    d: "M12.468 188.323A12.468 12.468 0 0 1 .016 176.484Q0 176.8 0 177.112a12.468 12.468 0 1 0 24.935 0q0-.316-.016-.628a12.468 12.468 0 0 1-12.452 11.839",
    transform: "translate(0 -164.645)",
    style: {
      fill: "#ed853a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 39594",
    d: "M50.193 56.64c-10.47 0-10.484-10.3-10.47-10.518a10.492 10.492 0 0 1 20.941 0c.014.222 0 10.518-10.47 10.518",
    transform: "translate(-37.726 -34.543)",
    style: {
      fill: "#fd9956"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 39595",
    d: "M49.932 186.3a10.492 10.492 0 0 1-10.47-9.82c-.014.222-.022.446-.022.671a10.492 10.492 0 1 0 20.983 0c0-.226-.008-.449-.022-.671a10.492 10.492 0 0 1-10.47 9.82",
    transform: "translate(-37.464 -164.68)",
    style: {
      fill: "#fd9956"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBronzeMedal);
export default __webpack_public_path__ + "static/media/bronze-medal.5d359f4de6adc4962c04218398f35e41.svg";
export { ForwardRef as ReactComponent };